import { alpha, darken, lighten, type PaletteOptions } from '@mui/material'

import { colors } from './colors'

export const palette: PaletteOptions = {
  background: {
    default: colors.common.white,
    paper: colors.common.white,
  },
  text: {
    primary: colors.brandBlack[500],
    secondary: alpha(colors.brandBlack[500], 0.87),
    disabled: alpha(colors.brandBlack[500], 0.38),
  },
  primary: {
    main: colors.brandGreen[500],
    light: colors.brandGreen[100],
    dark: colors.brandGreen[700],
    contrastText: colors.brandBlack[500],
  },
  secondary: {
    main: colors.grey[100],
    light: colors.grey[50],
    dark: colors.grey[200],
    contrastText: colors.brandBlack[500],
  },
  info: {
    main: colors.lightGreen[100],
    light: lighten(colors.lightGreen[100], 0.2),
    dark: darken(colors.lightGreen[100], 0.3),
    contrastText: colors.brandBlack[500],
  },
  success: {
    main: colors.green[800],
  },
  warning: {
    main: colors.orange[800],
  },
  error: {
    main: colors.red[700],
  },
}
